module.exports = __webpack_public_path__ + "site/img/team_member_陳柏彥.c9e611db.jpg";